<template>
  <div class="app-sales-report">
    <AppSalesReportForm />
  </div>
</template>

<script>
import AppSalesReportForm from './AppSalesReportForm';

export default {
  name: 'AppSalesReport',

  components: {
    AppSalesReportForm,
  },
};
</script>
